export const NAMESPACE = 'KanBo/boardInfo/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_BOARD_INFO = NAMESPACE + 'SET_BOARD_INFO'

const initialState = {
  byId: {}
}

const boardInfoDefaults = {
  description: null,
  creationDate: null,
  startDate: null,
  endDate: null,
  responsibleUserId: null,
  estimatedBudget: {
    value: 0,
    currency: null,
  },
  cardsCount: 0,
  usersCount: 0
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...boardInfoDefaults,
            ...state.byId[action.payload.id],
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        byId: { ...state.byId }
      }
      action.payload.forEach(item => {
        newState.byId[item.id] = {
          ...boardInfoDefaults,
          ...newState.byId[item.id],
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    case SET_BOARD_INFO:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            ...action.payload
          }
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (boardArray) {
  return {
    type: ADD_ARRAY,
    payload: boardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setBoardInfo (data) {
  return {
    type: SET_BOARD_INFO,
    payload: data
  }
}
